import { EModalSize, EPredefinedModalIds } from 'src/constants/modals';
import { FormSignup, useSignUpFormData } from 'src/components/FormSignup';
import React, { useState } from 'react';

import { BaseButton } from 'src/components/BaseButton';
import { BaseClose } from 'src/components/BaseClose';
import { BaseGenericModal } from 'src/components/BaseGenericModal';
import { BaseIcon } from 'src/components/BaseIcon';
import { BaseLink } from 'src/components/BaseLink';
import { CustomScrollbar } from 'src/components/CustomScrollbar';
import { FormForgotPassword } from 'src/components/FormForgotPassword';
import { FormLogin } from 'src/components/FormLogin';
import { TAuthRegisterFormsProps } from './AuthRegisterForms.types';
import { closeModal } from 'src/redux/modals/modals.slice';
import s from './AuthRegisterForms.module.scss';
import { termsAndConditions } from 'src/components/ModalAuth/termsAndConditions.data';
import { useAppDispatch } from 'src/redux/store';

export const AuthRegisterForms: React.FC<TAuthRegisterFormsProps> = ({
  showCloseButton,
  onCloseButtonClick,
  onSuccess,
}) => {
  const dispatch = useAppDispatch();
  const { formData, handleFieldChange } = useSignUpFormData();

  const [showLoginBlock, setShowLoginBlock] = useState<boolean>(true);
  const [forgotPassword, setForgotPassword] = useState<boolean>(false);

  return (
    <>
      <div>
        {(showCloseButton || forgotPassword) && (
          <BaseClose
            className={s.closeBtn}
            onClick={() => {
              setForgotPassword(false);
              if (!forgotPassword && onCloseButtonClick) {
                onCloseButtonClick();
              }
            }}
          />
        )}

        {!forgotPassword ? (
          <>
            <header className={s.formSwitches}>
              <BaseLink
                className={s.formSwitch}
                onClick={() => setShowLoginBlock(true)}
                isActive={showLoginBlock}
                theme="2">
                Login
              </BaseLink>
              <BaseLink
                className={s.formSwitch}
                onClick={() => setShowLoginBlock(false)}
                isActive={!showLoginBlock}
                theme="2">
                Signup
              </BaseLink>
            </header>

            {showLoginBlock ? (
              <>
                <FormLogin className={s.formLogin} onSuccess={onSuccess} />
                <p className={s.forgotPassword}>
                  Forgot password?{'  '}
                  <a onClick={() => setForgotPassword(true)} className={s.forgotPasswordCTA}>
                    Reset
                  </a>
                </p>
              </>
            ) : (
              <FormSignup
                className={s.formSignup}
                onSuccess={onSuccess}
                {...{ formData, handleFieldChange }}
              />
            )}
          </>
        ) : (
          <>
            <header>
              <h1 className={s.heading}>Password recovery</h1>
            </header>

            <FormForgotPassword />
          </>
        )}
      </div>

      <BaseGenericModal
        className={s.modal}
        modalId={EPredefinedModalIds.MODAL_TERMS_AND_CONDITIONS}
        size={EModalSize.XL650}>
        <BaseClose
          className={s.closeBtn}
          onClick={() => {
            dispatch(closeModal(EPredefinedModalIds.MODAL_TERMS_AND_CONDITIONS));
          }}
        />

        <div className={s.termsWrapper}>
          <header className={s.termsHeader}>
            <BaseIcon className={s.gsLogo} icon="gs-logo-2" size={74} />
            <h1 className={s.heading2}>Terms and Conditions</h1>
          </header>

          <CustomScrollbar className={s.termsContent}>
            <main dangerouslySetInnerHTML={{ __html: termsAndConditions }}></main>
          </CustomScrollbar>

          <footer className={s.termsFooter}>
            <BaseButton
              className={s.termsBtn}
              theme="grey3"
              onClick={() => {
                handleFieldChange({ name: 'termsAccepted', value: false });
                dispatch(closeModal(EPredefinedModalIds.MODAL_TERMS_AND_CONDITIONS));
              }}>
              Decline
            </BaseButton>
            <BaseButton
              className={s.termsBtn}
              onClick={() => {
                handleFieldChange({ name: 'termsAccepted', value: true });
                dispatch(closeModal(EPredefinedModalIds.MODAL_TERMS_AND_CONDITIONS));
              }}>
              I accept the Terms and Conditions
            </BaseButton>
          </footer>
        </div>
      </BaseGenericModal>
    </>
  );
};
